var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isFullScreen)?_c('Navbar',{on:{"notice-change":_vm.noticeDialog}}):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.key}),_vm._v(" "),(!_vm.isFullScreen)?_c('Bomter'):_vm._e(),_vm._v(" "),_c('Notice',{ref:"nForm"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78cb870e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 